let event = require('cocos/framework/components/event')
const Event = require("hecore/EventDispatcher").Event;
let { SOCKET_SEND_ACTION, SOCKET_RECEIVE_ACTION } = require('./service/socket-const')
let FriendPvpActivityLogic = xClass("FriendPvpActivityLogic", event)
let {ErrcodeMap} = require("activity/PvpActivity/config")
let instance = null
let {FriendPvpManager} = require("./FriendPvpManager")
// let FriendPvpActivityIcon = require("./FriendPvpActivityIcon")

FriendPvpActivityLogic.getInstance = function (callback) {
    if (!instance) {
        instance = FriendPvpActivityLogic.create(callback)
    }else{
        if (callback){
            callback();
        }
    }
    return instance
}
FriendPvpActivityLogic.prototype.ctor = function (callback) {
    let self = this
    self.bind(self)
    self.pvpManager = FriendPvpManager.getInstance()
    self.initEvent()
    self.isFriendPvp = true; // 新pvp

    self.panel = null;
    self.matchPanel = null;
    self.isShowingPanel = false;
    self.closeCb = null; // 主面板关闭时调用（目前只有回归礼用到）

    self.pvpLevelTime = 600; // 单局时间上限
    CfgManager.load("friend_pvp")
    .then((data) => {
        var config = data.get("friend_pvp");
        self.pvpLevelTime = config.pvp_level_effectivetime;
        self.pvpOff = config.pvp_off; // 根据配置的平台不显示icon
        CfgManager.release("friend_pvp");
        if (callback){
            callback();
        }
    });
}
FriendPvpActivityLogic.prototype.isSupport = function () {
    return (META.platform == XcloverPlatform.qq || META.platform == XcloverPlatform.wechatgame || META.platform == XcloverPlatform.he)
}
FriendPvpActivityLogic.prototype.initEvent = function () {
    let self = this
    self.pvpManager.on(SOCKET_RECEIVE_ACTION.CreateRoom, handler(self, self.onCreateRoom))
    self.pvpManager.on(SOCKET_RECEIVE_ACTION.JoinRoom, handler(self, self.onJoinRoom))
    self.pvpManager.on(SOCKET_RECEIVE_ACTION.LeaveRoom, handler(self, self.onLeaveRoom))
    self.pvpManager.on(SOCKET_RECEIVE_ACTION.PvpLeaveRoom, handler(self, self.onPvpLeaveRoom))
    self.pvpManager.on(SOCKET_RECEIVE_ACTION.DispatcherConfig, handler(self, self.onDispatcherConfig))
    self.pvpManager.on(SOCKET_RECEIVE_ACTION.Restart, handler(self, self.onDispatcherServerRestart))
    self.pvpManager.on(SOCKET_RECEIVE_ACTION.Error, handler(self, self.handleSocketError))
    self.pvpManager.on("socket_error", handler(self, self.socketErrorHandler))
    self.pvpManager.on(SOCKET_RECEIVE_ACTION.SocketClosed, handler(self, self.socketClosedByServer))
    // self.pvpManager.on(SOCKET_RECEIVE_ACTION.Heart, handler(self, self.recvHeart));
    self.pvpManager.on(SOCKET_RECEIVE_ACTION.PvpResult, handler(self, self.showGameResult));
    self.pvpManager.on(SOCKET_RECEIVE_ACTION.PvpRobotResult, handler(self, self.showRobotGameResult));

    var currentScene = cc.director._runningScene
    if (currentScene && currentScene.name == "GameScene"){
        currentScene.initSocketEvent();
    }
}
FriendPvpActivityLogic.prototype.resetStatus = function () {
    let self = this
    self.closedByClient = false
    self.closedByServer = false
    self.reconnenting = false
    self.reJoinRoom = false
    self.enemyHasWaitResult = false;
    self.pvpManager.id = null
    self.pvpManager.me = null
    self.pvpManager.you = null
    self.pvpManager.gameResult = {
        self:{
            targetFinish:0, targetTotal:0, score:0, time:0, reslut:0
        },
        enemy:{
            targetFinish:0, targetTotal:0, score:0, time:0, reslut:0
        }
    }
    self.pvpManager.isInviteMode = true; // 是否是被邀请的
    self.pvpManager.isInvitedPlayer = true; // 是否是被邀请的
    self.pvpManager.gameRestTime = -1; // 游戏内剩余时间，通过心跳表更新
    self.pvpManager.enemyHasLeftRoom = false; // 对手是否已经离开了房间
}

FriendPvpActivityLogic.prototype.isHomeScene = function () {
    let currentScene = cc.director._runningScene.name;
    return (!(currentScene === "GameScene" || currentScene === "LevelLoadingScene"));
}

FriendPvpActivityLogic.prototype.onCreateRoom = function (evt) {
    let self = this
    if (self.pvpManager.isInviteMode){
        self.panel && self.panel.onCreateRoom();
    }else{
        self.matchPanel && self.matchPanel.onCreateMatchRoom();
    }
}
FriendPvpActivityLogic.prototype.onJoinRoom = function (evt) {
    let self = this
    if (self.panel) {
        let gameResult = self.pvpManager.gameResult
        cc.log("gameResult", gameResult)
        if (gameResult && gameResult.enemyIsOut) {
            self.reJoinRoom = true
        }
    }
    if (self.matchPanel){
        self.matchPanel.onJoinRoom(evt);
    }
}
FriendPvpActivityLogic.prototype.showQuitPanel = function(isEnemeyQuit, quitCb, resumeCb){
    var self = this;

    if (isEnemeyQuit){
        // 对方退出后我方也要离开房间关闭房间
        self.pvpManager.pvpLeaveRoom();
        self.pvpManager.enemyHasLeftRoom = true;
        var cb = function(){
            self.resetStatus();
            self.pvpManager.enemyHasLeftRoom = true;
            self.pvpManager.clearEvent()
            self.pvpManager.initSocket()
        }
        self.closeRoom(cb, cb);
    }

    function resOnSuccess() {
        var [QuitPanel, QuitPanelEvent] = unpack(require("activity/PvpActivity/PvpQuitPanel"));
        cc.log(QuitPanel, QuitPanelEvent)
        self.quitPanel = QuitPanel.show(self, isEnemeyQuit, quitCb);
        if (resumeCb){
            resumeCb(self.quitPanel);
        }
        
    }
    function resOnFail() {
        Toast.make(getText("error.tip.timeout"))
    }
    preloadWithLoading(["packed/PvpQuitRes.pack"], resOnSuccess, resOnFail, resOnFail);
}
FriendPvpActivityLogic.prototype.onLeaveRoom = function (evt) {
    cc.log("*************FriendPvpActivityLogic onLeaveRoom**************")
    let self = this
    if (self.panel) {
        self.panel.onLeaveRoom();
        self.closedByClient = true;
        self.pvpManager.leaveRoom();
    }
    
    var currentScene = cc.director._runningScene.name;
    if (self.matchPanel != null && currentScene == "HomeScene") {
        self.matchPanel.clearMatchTask();
        self.matchPanel.onClose();
        self.matchPanel = null;
    }

    var cb = function(){
        self.resetStatus();
        self.pvpManager.clearEvent()
        self.pvpManager.initSocket()
    }
    self.pvpManager.closeSocket(cb, cb);
}
FriendPvpActivityLogic.prototype.onPvpLeaveRoom = function (evt) {
    cc.log("*************FriendPvpActivityLogic onPvpLeaveRoom**************")
    let self = this
    if (cc.Director.getInstance().getRunningScene().name != "HomeScene"){
        // 在局内对方退出
        var callback = function(){
            self.finishGame(true);
        }
        self.showQuitPanel(true, callback);
        return;
    }
}
FriendPvpActivityLogic.prototype.onDispatcherConfig = function (evt) {
    let self = this
    let data = evt.data
    cc.log("********onDispatcherConfig********", data);


    var consumeTicket = function(){
        var consumeSuccess = function(evt1){
            var gotoLevel = function(){
                cc.log("********gotoLevel********", data);
                self.levelLogic = require("activity/PvpActivity/startEndLevelLogic/StartPvpLevelLogic").create(data.levelId, self.isFriendPvp)[0]
                self.levelLogic.start(data)
                self.reJoinRoom = false
        
                self.leftTime = self.pvpLevelTime;
                self.startTime = Localhost.time();
                if (self.heart){
                    clearInterval(self.heart);
                    clearInterval(self.heartLocal);
                }
                self.pvpManager.sendHeart();
                self.heart = setInterval(()=>{
                    self.pvpManager.sendHeart();
                }, 5000);
                self.heartLocal = setInterval(()=>{
                    self.leftTime -= 1;
                    self.pvpManager.dispatchEvent({
                        name: SOCKET_RECEIVE_ACTION.Heart,
                        data: {leftTime: self.leftTime}
                    })
                }, 1000);
            }

            if (self.matchPanel){
                self.matchPanel.onClose(gotoLevel);
                self.matchPanel = null;
            }

            // if (__DEBUG){
            //     gotoLevel();
            // }

            if (self.panel){
                self.panel.onClose(null, null, true);
                self.panel = null;
            }

            self.pvpManager.activityInfo.freeCount = evt1.data.freeCount;
            self.pvpManager.activityInfo.adTicketCount = evt1.data.adTicketCount;
        }
        var consumeFail = function(evt1){
            if (self.matchPanel){
                self.closeMatchPanel();
            }
        }

        var http = PvpConsumeHttp.new();
        http.addEventListener(Events.kComplete, consumeSuccess);
        http.addEventListener(Events.kError, consumeFail);
        http.addEventListener(Events.kCancel, consumeFail);
        http.load();
    }

    consumeTicket();

    if (self.matchPanel){
        self.matchPanel.clearMatchTask();
        self.matchPanel.clearCheckMatchPlayerTask();
    }

    self.enemyHasWaitResult = false;
    self.isReadyShowResult = false;
    self.resultPanel = null;
}

FriendPvpActivityLogic.prototype.clearHeart = function () {
    let self = this
    if (self.heart){
        clearInterval(self.heart);
    }
    if (self.heartLocal){
        clearInterval(self.heartLocal);
    }
    self.pvpManager.heartPing = 0;
    self.pvpManager.heartPong = 0;
}

FriendPvpActivityLogic.prototype.finishGame = function (isQuitInGame = false) {
    cc.log("*************finishGame************")
    var self = this
    if (self.heart){
        clearInterval(self.heart);
        clearInterval(self.heartLocal);
    }
    
    self.pvpManager.removeEventListenersByEvent(SOCKET_RECEIVE_ACTION.Heart);
    
    self.clearRobotTask();
    self.closedByClient = true;
    if (self.pvpManager.isRobot){
        // 机器人没有房间
    }else{
        if (isQuitInGame){
            self.pvpManager.pvpLeaveRoom();
        }else{
            self.pvpManager.leaveRoom();
        }
    }
    var scene = cc.Director.getInstance().getRunningScene();
    if (scene.name == "GameScene" || scene.name == "ReplayGameScene"){
        cc.Director.getInstance().popScene();
    }

    if (self.pvpManager.isRobot){
        // 机器人没有房间
        self.showPanel();
    }else{
        var cb = function(){
            self.resetStatus();
            self.showPanel();
        }
        self.pvpManager.closeSocket(cb, cb);
    }
}

if (__DEBUG) {
    // 测试用直接进pvp对局
    FriendPvpActivityLogic.prototype.debugGotoLevel = function(levelId){
        let self = this
        self.pvpManager.id = 10000;
        self.pvpManager.you = {
            avatar:null
        }
        self.pvpManager.me = {
            avatar:null
        }
        var data = {
            gameTime:0,
            levelId:levelId,
            randomSeed:1574925659365,
            isFriendPvp:true
        }
        self.levelLogic = require("activity/PvpActivity/startEndLevelLogic/StartPvpLevelLogic").create(data.levelId, self.isFriendPvp)[0]
        self.levelLogic.start(data)
        self.reJoinRoom = false

        self.leftTime = self.pvpLevelTime;
        self.startTime = Localhost.time();
    }
}
FriendPvpActivityLogic.prototype.showIcon = function () {
    let self = this
    if (this.icon) {
        return
    }

    var isShow = true;
    if (self.pvpOff){
        for(var i = 0; i < self.pvpOff.length; i++){
            if (window.mini && self.pvpOff[i] == mini.getPlatform()){
                isShow = false;
            }
        }
    }

    if (!isShow){
        return;
    }
    //
    GlobalEventDispatcher.getInstance().dispatchEvent(Event.new(kGlobalEvents.kWelfareCenterAction,
        {
            id: WelfareCenterId.friendPvp,
            redDot: self.getRedDot(),
        })
    )

    self.hasClickedIcon = false;
    //防止监听两次
    if(!self._kWelfareCenterClick) {
        self._kWelfareCenterClick = function (event) {
            if (event.data.id == WelfareCenterId.friendPvp) {
                // let dcSession = event.data.session || 0;
                self.hasClickedIcon = true;
                setTimeout(()=>{
                    self.hasClickedIcon = false;
                }, 1000);
                function openPanel(authorize){
                    if (authorize){
                        refreshAuthorize()
                    }
                    Localhost.setPvpClickToday()
                    self.resetStatus()
                    self.showPanel()
                }
                DCAssist.dc4ClickIcon("PVP", "click_pvp_icon", {"abtest":"new"});
                AuthorizeMgr.checkAuthorize(openPanel, openPanel, getText("wechat.info.ask.pvp.txt"), "pvp");
            }
        }
        GlobalEventDispatcher.getInstance().addEventListener(
            kGlobalEvents.kWelfareCenterClick,
            self._kWelfareCenterClick,
        );
    }
    
    var onSuccess = function(evt) {
        const ticket = evt.data.freeCount + evt.data.adTicketCount;
        //这里只在有红点时更新
        if(evt.data.reportRedPoint || ticket > 0) {
            GlobalEventDispatcher.getInstance().dispatchEvent(Event.new(kGlobalEvents.kWelfareCenterAction,
                {
                    id: WelfareCenterId.friendPvp,
                    redDot: true,
                })
            )
        }

        UserManager.getInstance().updateUserInfoByKey("pvpGuide", evt.data.haveGuide);
    }
    var onFail = function(evt){
        cc.error(evt);
    }
    var http = GetPvpInfoHttp.new();
    http.addEventListener(Events.kComplete, onSuccess);
    http.addEventListener(Events.kError, onFail);
    http.addEventListener(Events.kCancel, onFail);
    http.load();
}
const PROMPT_LAST_DISPLAY_DAY_KEY = "friend.pvpicon.last.display.day"; // 上一次新建icon自然日
//宝箱气泡和有票，都归为福利中心红点
FriendPvpActivityLogic.prototype.getRedDot = function() {
    let self = this;
    const lastDisplayDay = parseInt(UserLocalSettings.getSetting(PROMPT_LAST_DISPLAY_DAY_KEY), 10);    
    const today = Localhost.timeInDay();
    if (isNaN(lastDisplayDay) || lastDisplayDay != today)  {
        return true;
    }
    if (self.pvpManager.activityInfo) {
        const ticket = self.pvpManager.activityInfo.freeCount + self.pvpManager.activityInfo.adTicketCount;
        return ticket > 0;
    }
    return false;
}
FriendPvpActivityLogic.prototype.updateIconNum = function () {
    let self = this;
    if (self.icon && self.pvpManager.activityInfo) {
        var ticket = self.pvpManager.activityInfo.freeCount + self.pvpManager.activityInfo.adTicketCount;
        self.icon.updateTicketNum(ticket)
        
    }
}

FriendPvpActivityLogic.prototype.closePanel = function () {
    let self = this;
    if (self.panel) {
        self.isShowingPanel = false;
        if (self.closeCb){
            self.closeCb();
            self.closeCb = null;
        }
        self.panel.onClose();
        self.panel = null;
        self.closeRoom();
    }
}

FriendPvpActivityLogic.prototype.addCloseCb = function(callback){
    let self = this;
    self.closeCb = callback;
}

FriendPvpActivityLogic.prototype.showPanel = function () {
    let self = this
    if (self.isBusy || self.panel) {
        return
    }
    self.isBusy = true
    self.closedByClient = false
    self.closedByServer = false
    self.isShowingPanel = true;
    
    self.pvpManager.clearEvent()
    self.pvpManager.initSocket()
    let res = ["packed/PvpRes.pack"]
    let frame_res = DressManager.getInstance().getNeedFrameRes()
    res = res.concat(frame_res)
    var onSuccess = function(evt){
        function resOnSuccess() {
            self.pvpManager.setActivityInfo(evt.data);
            var FriendPvpActivityMainPanel = require("activity/PvpActivity/FriendPvpActivityMainPanel");
            var resetBusy = function(){
                self.isBusy = false;
            }
            self.panel = FriendPvpActivityMainPanel.create(self, resetBusy, handler(self, self.closePanel),res);
            //        
            const today = Localhost.timeInDay();
            UserLocalSettings.setSetting(PROMPT_LAST_DISPLAY_DAY_KEY, today);

            GlobalEventDispatcher.getInstance().dispatchEvent(Event.new(kGlobalEvents.kWelfareCenterAction,
                {
                    id: WelfareCenterId.friendPvp,
                    redDot: self.getRedDot(),
                })
            )
            //
            GlobalEventDispatcher.getInstance().dispatchEvent(Event.new(kGlobalEvents.kWelfareCenterPanel,
                {
                    id: WelfareCenterId.friendPvp,
                })
            )
        }
        function resOnFail() {
            Toast.make(getText("error.tip.timeout"))
        }
        preloadWithLoading(res, resOnSuccess, resOnFail, resOnFail);
    }
    var onFail = function(evt){
        self.isBusy = false;
        cc.error(evt);
        Toast.make(getText("error.tip." + tostring(evt.data)));
    }
    var http = GetPvpInfoHttp.new();
    http.addEventListener(Events.kComplete, onSuccess);
    http.addEventListener(Events.kError, onFail);
    http.addEventListener(Events.kCancel, onFail);
    http.load();
}

FriendPvpActivityLogic.prototype.closeMatchPanel = function (needCloseMainPanel = false, forceCloseSocket = false) {
    let self = this;
    if (self.matchPanel) {
        self.matchPanel.clearMatchTask();
        self.matchPanel.onClose();
        self.matchPanel = null;
        if (self.pvpManager.isInvitedPlayer && !forceCloseSocket){
            // 被邀请的人还没接收邀请时还没加入房间所以不需要closeRoom，加入房间后是不能退出邀请的也就不会走进来
        }else{
            var cb = function(){
                self.pvpManager.clearEvent()
                self.pvpManager.initSocket()
            }
            self.closeRoom(cb, cb);
        }
    }
    if (needCloseMainPanel && self.panel){
        self.closePanel();
        return;
    }
    var cb = function(){
        if (self.panel){
            self.panel.resetBusy();
        }
        self.resetStatus();
        self.pvpManager.clearEvent()
        self.pvpManager.initSocket()
    }
    self.pvpManager.closeSocket(cb, cb);
}

FriendPvpActivityLogic.prototype.showMatchPanel = function (invitedParams, activityInfo, onCloseCallback) {
    let self = this;
    if (self.isBusy || self.matchPanel || !self.isHomeScene()) {
        return
    }
    self.isBusy = true;

    var close = function(){
        if (onCloseCallback){
            onCloseCallback();
        }
        self.closeMatchPanel();
    }

    function resOnSuccess() {
        self.isBusy = false;
        self.isShowingMatchPanel = true;
        var pvpActivityMatchPanel = require("activity/PvpActivity/FriendPvpActivityMatchPanel");
        self.matchPanel = pvpActivityMatchPanel.show(self, close, invitedParams, activityInfo);
        if (invitedParams){
            // 点分享进来的初始化
            self.pvpManager.clearEvent();
            self.pvpManager.roomHost = invitedParams.inviteCode;
            self.pvpManager.initSocket();
        }
    }
    function resOnFail() {
        self.isBusy = false;
        Toast.make(getText("error.tip.timeout"))
    }
    preloadWithLoading(["packed/PvpMatchRes.pack"], resOnSuccess, resOnFail, resOnFail);
}

FriendPvpActivityLogic.prototype.closeStandingPanel = function () {
    let self = this;
    if (self.standingPanel) {
        self.standingPanel.onClose();
        self.standingPanel = null;
    }
}

FriendPvpActivityLogic.prototype.showStandingPanel = function (refreshScoreCb) {
    cc.log("-----------------showStandingPanel--------------------")
    let self = this
    if (self.isBusy) {
        return
    }
    self.isBusy = true;

    function resOnSuccess() {
        self.isBusy = false;
        var pvpActivityStandingPanel = require("activity/PvpActivity/FriendPvpActivityStandingPanel");
        self.standingPanel = pvpActivityStandingPanel.show(self, handler(self, self.closeStandingPanel), refreshScoreCb);
        if (self.panel){
            self.standingPanel.setScoreTicketPositionAndAnim(self.panel.getScoreTxtPosition(), handler(self.panel, self.panel.showGetScoreTxtAnim)
                                                            , self.panel.getTicketIconPosition(), handler(self.panel, self.panel.showTicketNumAnim));
        }
    }
    function resOnFail() {
        self.isBusy = false;
        Toast.make(getText("error.tip.timeout"))
    }
    preloadWithLoading(["packed/PvpStandingRes.pack"], resOnSuccess, resOnFail, resOnFail);
}

FriendPvpActivityLogic.prototype.showResultWaitPanel = function (data) {
    cc.log("******************showResultWaitPanel********************");
    let self = this
    if (self.isBusy) {
        return
    }
    self.clearHeart();

    self.pvpManager.on(SOCKET_RECEIVE_ACTION.PvpResult, handler(self, self.showGameResult));
    data.leftTime = self.pvpLevelTime - Math.ceil((Localhost.time() - self.startTime)/1000);
    self.resultWaitData = data;

    if (self.enemyHasWaitResult == true){
        // 对方已经在等待的时候直接出结算
        self.isBusy = false;
        cc.log("not showResultWaitPanel");
        return
    }

    function resOnSuccess() {
        self.isBusy = false;
        var pvpActivityResultWaitPanel = require("activity/PvpActivity/FriendPvpActivityResultWaitPanel");
        if (self.isReadyShowResult){
            ResManager.release(["packed/PvpSettlement1Res.pack"]);
        }else{
            self.resultWaitPanel = pvpActivityResultWaitPanel.show(self, data, self.pvpLevelTime);
        }
    }
    function resOnFail() {
        self.isBusy = false;
        Toast.make(getText("error.tip.timeout"))
    }
    preloadWithLoading(["packed/PvpSettlement1Res.pack"], resOnSuccess, resOnFail, resOnFail);
}

FriendPvpActivityLogic.prototype.showGameResult = function(evt) {
    cc.log("******************showGameResult********************");
    var self = this;
    var data = evt.data;
    if (self.isBusy && !self.isReadyShowResult) {
        setTimeout(()=>{
            self.showGameResult(evt);
        }, 1000);
        return
    }

    // cc.log("data.result="+data.result+"(4是对方超时，5是自己超时)");

    if (data.result == 0){
        // 对方已经在等待
        self.enemyHasWaitResult = true;
        return;
    }else if (data.result == 4){
        // 对方超时等待结算
        return;
    }
 
    self.isBusy = true;
    self.isReadyShowResult = true;

    self.clearHeart();

    if (self.resultWaitPanel){
        self.resultWaitPanel.onClose();
    }

    var selfTargetFinish = self.resultWaitData.targetFinish;
    var targetTotal = self.resultWaitData.targetTotal;
    var selfScore = self.resultWaitData.score;
    var selfTime = self.resultWaitData.time;
    var selfResult = data.result;
    var enemyTargetFinish = data.targetCollect;
    var enemyScore = data.targetScore;
    var enemyTime = data.targetTime;
    var enemyResult = data.targetResult;
    self.pvpManager.gameResult = {
        self:{
            targetFinish:selfTargetFinish, targetTotal:targetTotal, score:selfScore, time:selfTime, result:selfResult
        },
        enemy:{
            targetFinish:enemyTargetFinish, targetTotal:targetTotal, score:enemyScore, time:enemyTime, result:enemyResult
        }
    }
    cc.log(self.pvpManager.gameResult);

    function resOnSuccess() {
        self.isBusy = false;
        if (self.resultPanel){
            return;
        }
        var pvpActivityResultPanel = require("activity/PvpActivity/FriendPvpActivityResultPanel");
        self.resultPanel = pvpActivityResultPanel.show(self, self.pvpManager.gameResult);
    }
    function resOnFail() {
        self.isBusy = false;
        Toast.make(getText("error.tip.timeout"))
    }
    preloadWithLoading(["packed/PvpSettlement2Res.pack"], resOnSuccess, resOnFail, resOnFail);

    // 有结算等待面板的话关掉
    if (self.resultWaitPanel){
        self.resultWaitPanel.onClose(null, null, true);
        self.resultWaitPanel = null;
    }

}

FriendPvpActivityLogic.prototype.onDispatcherServerRestart = function () {
    let self = this
    self.panel && self.panel.onRestartGame();
    self.resultWaitPanel = null;
    self.resultPanel = null;
}

FriendPvpActivityLogic.prototype.onClickRestartGame = function () {
    let self = this

    function onNormalRestart() {
        self.pvpManager.restartGame()
        self.panel.onClickRestartGame()
        Toast.make("请耐心等待好友加入！")
    }
    // 如果是 游戏中直接退出的
    let gameResult = self.pvpManager.gameResult
    if (self.panel.isOwner()) {
        // 如果是在游戏内退出的
        // gameResult.enemyIsOut 表示enemy 半途退出
        if (gameResult && gameResult.enemyIsOut) {
            // 如果是在游戏内退出又进入的，onJoinRoom 就已经初始化好界面了，所以不需要操作
            // 如果是半路退出
            if (self.reJoinRoom) {
                
            }else {
                self.panel.retoreEnemyInfo()
            }
            return
        }
        // 如果是在结算面板关闭的时候不需要做什么，那时候已经可以收到消息
        if (self.pvpManager.isEnemyLeave()) {
            return
        }
        onNormalRestart()
    }else {
        // 只要是房主退出了，直接显示房主退出
        if (self.pvpManager.isEnemyLeave() || (gameResult && gameResult.enemyIsOut)) {
            self.panel.onOwnerLeave()
            return
        }
        onNormalRestart()
    }
}
FriendPvpActivityLogic.prototype.handleNoRoom = function () {
    let self = this;
    self.matchPanel && self.matchPanel.handleNoRoom();
}
FriendPvpActivityLogic.prototype.handlePvpNotOpen = function () {
    let self = this;
    Toast.make("友谊赛暂时还未开放哦！！")
    self.panel && self.panel.handlePvpNotOpen();
}
FriendPvpActivityLogic.prototype.handleRoomFulled = function () {
    let self = this
    self.matchPanel && self.matchPanel.handleRoomFulled()
}
FriendPvpActivityLogic.prototype.handleSocketError = function (evt) {
    cc.log("FriendPvpActivityLogic handleSocketError");
    let self = this
    let errcode = evt.data && evt.data.errcode
    if (errcode) {
        switch (errcode) {
            case ErrcodeMap.NoOwner:
                self.handleNoRoom();
                var cb = function(){
                    self.pvpManager.clearEvent()
                    self.pvpManager.initSocket()
                }
                self.closeRoom(cb, cb);
                // Toast.make(getText("房主不存在"));
                break;
            case ErrcodeMap.PvpNotOpen:
                self.closedByClient = true;
                self.handlePvpNotOpen()
                break;
            case ErrcodeMap.RoomFulled:
                self.handleRoomFulled()
                break;
            case ErrcodeMap.GameOvered:
                self.handleGameOvered()
                break;
            case ErrcodeMap.FriendPvpNoBeHelpTimes:
                self.handleFriendPvpNoBeHelpTimes()
                break;
            case ErrcodeMap.FriendPvpNoTicket:
                self.handleFriendPvpNoTicket()
                break;
            case ErrcodeMap.FriendPvpEnemyOffline:
                self.handleFriendPvpEnemyOffline()
                break;
            case ErrcodeMap.FriendPvpNoHelpTimes:
                self.handleFriendPvpNoHelpTimes();
                break;
            case ErrcodeMap.FriendPvpRoomFull:
                self.handleFriendPvpRoomFull();
                break;
        }
    }
}

FriendPvpActivityLogic.prototype.handleFriendPvpRoomFull = function () {
    var self = this;
    var cb = function(){
        self.pvpManager.clearEvent()
        self.pvpManager.initSocket()
    }
    self.closeRoom(cb, cb);
    Toast.make("对战房间已满");
}
FriendPvpActivityLogic.prototype.handleGameOvered = function () {
    var self = this;
    var finish = function(){
        self.finishGame();
    }
    Toast.make("当前对战已经结束，请重新发起挑战吧！", 1.2, finish);
}
FriendPvpActivityLogic.prototype.handleFriendPvpNoBeHelpTimes = function () {
    var self = this
    self.matchPanel && self.matchPanel.handleFriendPvpNoBeHelpTimes();
}
FriendPvpActivityLogic.prototype.handleFriendPvpNoTicket = function () {
    var self = this
    self.matchPanel && self.matchPanel.handleFriendPvpNoTicket();
}
FriendPvpActivityLogic.prototype.handleFriendPvpEnemyOffline = function () {
    var self = this
    self.matchPanel && self.matchPanel.handleFriendPvpEnemyOffline();
}
FriendPvpActivityLogic.prototype.handleFriendPvpNoHelpTimes = function(){
    var self = this
    self.matchPanel && self.matchPanel.handleFriendPvpNoHelpTimes();
}
FriendPvpActivityLogic.prototype.closeRoom = function (onSuccess, onFail) {
    cc.log("----closeRoom----");
    let self = this;
    self.closedByClient = true;
    self.clearHeart();
    self.pvpManager.closeSocket(onSuccess, onFail);
}
FriendPvpActivityLogic.prototype.socketErrorHandler = function () {
    let self = this
    cc.log(`socketErrorHandler: closedByClient: ${self.closedByClient},reconnenting: ${self.reconnenting},`)
    if ((self.closedByClient || self.reconnenting) && !self.isHomeScene()) {
        return
    }
    self.reconnenting = true
    function reconnent() {
        self.pvpManager.startReconnect(() => {
            Toast.make("重新连接服务器成功！")
            self.reconnenting = false
        }, () => {
            setTimeout(() => {
                reconnent();
            }, 1000);
        }, )
    }
    reconnent()
}
FriendPvpActivityLogic.prototype.socketClosedByServer = function () {
    let self = this
    cc.log(`SocketClosed: closedByClient: ${self.closedByClient},reconnenting: ${self.reconnenting},`)

    if (self.closedByClient || self.reconnenting){
        return;
    }
    if (self.isHomeScene()) {
        if (self.closedByClient){
            if (self.matchPanel){
                self.matchPanel.clearMatchTask();
                self.matchPanel.onClose();
                self.matchPanel = null;
                self.closedByClient = false
                self.closedByServer = false
                var cb = function(){
                    self.pvpManager.clearEvent()
                    self.pvpManager.initSocket()
                }
                self.pvpManager.closeSocket(cb, cb);
            }
            return
        }
    }else{
        self.closedByClient = false
        self.closedByServer = false
        
        function reInitEvent() {
            self.pvpManager.clearEvent()
            self.pvpManager.initSocket()
        }
        var connectOne = null;
        function reconnent() {
            self.reconnenting = true;
            self.pvpManager.startReconnect(() => {
                Toast.make("重新连接服务器成功！")
                self.reconnenting = false
            }, () => {
                setTimeout(() => {
                    connectOne();
                }, 1000);
            })
        }
        connectOne = function(){
            // websocket 在 close 之后会清除之前绑定的事件，这里重新绑定
            reInitEvent()
            reconnent()
        }
        connectOne();
    }
}

FriendPvpActivityLogic.prototype.startRobotTask = function(){
    cc.log("********startRobotTask********")
    var self = this;
    self.clearRobotTask();
    self.robotSelfFinish = false;
    var curTime = Localhost.timeInSec();
    var startTime = curTime;
    var totalTime = self.pvpManager.you.time;
    var finishTime = curTime + totalTime; // 完成的时间
    var nextTime = curTime + Math.ceil(Math.random()*6); // 下一次分数的时间
    var curScore = 0;
    var finishScore = self.pvpManager.you.score; 
    cc.log("totalTime", totalTime);
    cc.log("finishScore", finishScore);
    self.robotTask = setInterval(()=>{
        if (self.robotTask == null){
            return;
        }
        curTime = Localhost.timeInSec();
        // cc.log("curTime", curTime, "finishTime", finishTime);
        if (curTime >= finishTime){
            self.enemyHasWaitResult = true;
            var evt = {score:finishScore};
            self.pvpManager.dispatchEvent({
				name: SOCKET_RECEIVE_ACTION.PvpUpdateProgress,
				data: evt
            })
            self.clearRobotTask();
            cc.log("----self.robotSelfFinish----", self.robotSelfFinish);
            cc.log("----self.pvpRobotResultData----", self.pvpRobotResultData);
            if (self.robotSelfFinish){
                self.pvpManager.dispatchEvent({
                    name: SOCKET_RECEIVE_ACTION.PvpResult,
                    data:self.pvpRobotResultData
                })
            }else{
                self.enemyHasWaitResult = true;
            }
        }else if (curTime >= nextTime){
            nextTime = curTime + Math.ceil(Math.random()*6);
            curScore = finishScore*(curTime-startTime)/totalTime;
            curScore = Math.floor(curScore/10)*10;
            // cc.log("curScore", curScore);
            var evt = {score:curScore};
            self.pvpManager.dispatchEvent({
				name: SOCKET_RECEIVE_ACTION.PvpUpdateProgress,
				data: evt
			})
        }
    }, 1000);
}

FriendPvpActivityLogic.prototype.showRobotGameResult = function(evt){
    cc.log("********showRobotGameResult********")
    var self = this;
    self.robotSelfFinish = true;
    var resultData = evt.data;
    if (self.enemyHasWaitResult){
        self.pvpManager.dispatchEvent({
            name: SOCKET_RECEIVE_ACTION.PvpResult,
            data:resultData
        })
    }else{
        self.pvpRobotResultData = resultData;
    }
}

FriendPvpActivityLogic.prototype.clearRobotTask = function(){
    cc.log("********clearRobotTask********")
    var self = this;
    if (self.robotTask){
        clearInterval(self.robotTask);
    }
    self.robotTask = null;
}

FriendPvpActivityLogic.prototype.resumeReplayGame = function(levelId, replay){
    cc.log("FriendPvpActivityLogic resumeReplayGame", replay);
    var self = this;

    var roomId = replay.roomId;
    if (!roomId){
        cc.log("数据错误没有roomId");
        return
    }

    var loadRes = function(){
        self.pvpManager.removeEventListenersByEvent(SOCKET_RECEIVE_ACTION.Heart);
        
        if (!self.isHomeScene()){
            return;
        }
        
        self.heart = setInterval(()=>{
            self.pvpManager.sendHeart();
        }, 5000);
        self.heartLocal = setInterval(()=>{
            self.leftTime -= 1;
            self.pvpManager.dispatchEvent({
                name: SOCKET_RECEIVE_ACTION.Heart,
                data: {leftTime: self.leftTime}
            })
        }, 1000);

        self.levelLogic = require("activity/PvpActivity/startEndLevelLogic/StartPvpLevelLogic").create(levelId, self.isFriendPvp)[0]
        self.levelLogic.startLevelReplay(replay)
    }

    self.reconnenting = true;
    function reconnent() {
        self.pvpManager.clearEvent()
        self.pvpManager.initSocket()
        self.pvpManager.startReconnect(() => {
            Toast.make("重新连接服务器成功！")
            self.reconnenting = false;
        
            self.leftTime = replay.leftTime;
            self.startTime = Localhost.time();
            if (self.heart){
                clearInterval(self.heart);
                clearInterval(self.heartLocal);
            }
            self.pvpManager.sendHeart();
            self.pvpManager.on(SOCKET_RECEIVE_ACTION.Heart, loadRes); //有心跳回包了再进关卡
        }, () => {
            setTimeout(() => {
                reconnent();
            }, 1000);
        }, )
    }

    var onSuccess = function(evt){
        self.pvpManager.setActivityInfo(evt.data);
        self.pvpManager.id = roomId;
        self.pvpManager.you = replay.you;
        self.pvpManager.me = replay.me;
        reconnent();
    }
    var onFail = function(evt){
        self.isBusy = false;
        cc.error(evt);
        Toast.make(getText("error.tip." + tostring(evt.data)));
    }
    var http = GetPvpInfoHttp.new();
    http.addEventListener(Events.kComplete, onSuccess);
    http.addEventListener(Events.kError, onFail);
    http.addEventListener(Events.kCancel, onFail);
    http.load();
}

module.exports = FriendPvpActivityLogic